import React from 'react';

export default function ActivityLog({ logs }) {
  return (
    <div className="bg-tf-surface border border-tf-primary" data-testid="activity-log">
      <div className="px-4 sm:px-5 py-3 sm:py-4 border-b border-tf-primary">
        <h2 className="font-heading font-bold text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] uppercase text-tf-text">Activity Log</h2>
      </div>
      {logs.length === 0 ? (
        <div className="px-4 sm:px-5 py-6 sm:py-8 text-center">
          <p className="font-body text-sm text-tf-text-2">No recent activity.</p>
        </div>
      ) : (
        <div className="max-h-[300px] sm:max-h-[400px] overflow-y-auto">
          {logs.map((log, i) => (
            <div key={i} className="px-4 sm:px-5 py-2.5 sm:py-3 border-b border-tf-border-muted last:border-b-0 hover:bg-tf-bg transition-colors duration-200" data-testid={`log-item-${i}`}>
              <div className="flex items-start justify-between gap-2">
                <span className="font-mono text-[9px] sm:text-[10px] font-bold text-tf-text capitalize">{formatAction(log.action)}</span>
                <span className="font-mono text-[8px] sm:text-[9px] text-tf-text-3 whitespace-nowrap">{formatTime(log.timestamp)}</span>
              </div>
              {log.details && Object.keys(log.details).length > 0 && (
                <p className="font-mono text-[9px] sm:text-[10px] text-tf-text-2 mt-0.5 truncate">{Object.entries(log.details).map(([k, v]) => `${k}: ${v}`).join(' · ')}</p>
              )}
              <div className="font-mono text-[8px] sm:text-[9px] text-tf-text-3 mt-0.5">ID: {log.telegram_id}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function formatAction(action) {
  const map = { start: 'Bot Started', role_selected: 'Role Selected', onboarded: 'User Onboarded', transact_start: 'Transaction Started', transaction_created: 'Transaction Created', verify_request: 'Verify Request', attest_request: 'Attest Request', status_check: 'Status Check' };
  return map[action] || action.replace(/_/g, ' ');
}

function formatTime(timestamp) {
  if (!timestamp) return '';
  const d = new Date(timestamp);
  const diffMins = Math.floor((new Date() - d) / 60000);
  if (diffMins < 1) return 'now';
  if (diffMins < 60) return `${diffMins}m`;
  const diffHrs = Math.floor(diffMins / 60);
  if (diffHrs < 24) return `${diffHrs}h`;
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}
